import { ChangeEvent, FC, ReactNode } from 'react';

import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material';

type WaveUICheckboxProps = CheckboxProps & {
  name: string;
  label: ReactNode;
  value?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
};

const WaveUICheckbox: FC<WaveUICheckboxProps> = ({
  name,
  label,
  value,
  onChange,
  ...props
}) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          id={`id_${name}`}
          onChange={onChange}
          inputProps={{ 'aria-label': 'controlled' }}
          {...props}
        />
      }
      name={name}
      value={value}
      label={label}
      labelPlacement='end'
      checked={props.checked}
    />
  );
};

export default WaveUICheckbox;
